export const alphaDomains = {
    config_ui_url: {
        type: 'environment',
        value: { __alpha_env__: 'ALPHA_UI_CONFIG_SERVICE_URL' },
    },
    config_service_url: {
        type: 'environment',
        value: { __alpha_env__: 'ALPHA_CONFIG_SERVICE_URL' },
    },
};
